export const pad = (n) => String(n).padStart(2, '0')

/** 'YYYY-MM-DD' → local Date. Built field-by-field, never `new Date(str)`,
 *  which parses as UTC and shifts the day for anyone east/west of Greenwich. */
export function parseISODate(str) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(str || ''))
  if (!m) return null
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
  return Number.isNaN(d.getTime()) ? null : d
}

/** Date → 'YYYY-MM-DD'. */
export function toISODate(d) {
  if (!d || Number.isNaN(d.getTime())) return ''
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

/** 'HH:mm' → the three 12-hour parts a user actually picks. */
export function parseTime(str) {
  const m = /^(\d{1,2}):(\d{2})/.exec(String(str || ''))
  if (!m) return { hour: null, minute: null, meridiem: null }
  const h24 = Number(m[1])
  if (h24 > 23 || Number(m[2]) > 59) return { hour: null, minute: null, meridiem: null }
  return { hour: h24 % 12 || 12, minute: Number(m[2]), meridiem: h24 >= 12 ? 'PM' : 'AM' }
}

/** 12-hour parts → 'HH:mm' (24h). */
export function toHM(hour, minute, meridiem) {
  const h24 = meridiem === 'PM' ? (hour % 12) + 12 : hour % 12
  return `${pad(h24)}:${pad(minute)}`
}
